import './scss/index.scss';
import ComponentsFactory from 'foundation/components-factory';
import NewsFeedComponent from './js/news-feed.component';
import NewsFeedListing from './js/news-feed-listing';

ComponentsFactory.getInstance().define('news-feed', NewsFeedComponent);

export * from './js/patterns';
export {
    NewsFeedListing
};
